import React, { useState } from 'react'
import { InfoBubble } from '../misc/InfoBubble'
import { SearchInput } from '../misc/SearchInput'
import { Table, TableBody, TableHeader, TableHeaderH } from '../misc/table'
import { FeatureSwitchButton } from './FeatureSwitchButton'
import { FeatureSwitchName } from './FeatureSwitches'
import { observer } from 'mobx-react'

export const SiteFeatureSwitches = observer(({ featureSwitchesSlice }) => {
  const [searchableFeatureSwitches, setSearchableFeatureSwitches] = useState([])

  const {
    featureSwitches: siteFeatureSwitches,
    fsDescriptions: descriptions,
    toggleFeatureSwitch
  } = featureSwitchesSlice
  
  const onSearch = value => {
    setSearchableFeatureSwitches(siteFeatureSwitches.filter(x => x.displayName.toLowerCase().includes(value)))
  }

  return (
    <div>
      <h2>Feature switches</h2>
      <SearchInput onSearch={onSearch} clearable placeholder="filter sites"/>
      {siteFeatureSwitches.length > 0 &&
        <Table sticky fullWidth>
          <TableHeader sticky>
            <tr>
              <TableHeaderH>Site name</TableHeaderH>
              {Object.keys(siteFeatureSwitches[0].featureSwitches).map((buttonName, key) => (
                <TableHeaderH key={key}>
                  <FeatureSwitchName name={buttonName}/>
                  <InfoBubble content={descriptions[buttonName]} id={buttonName}/>
                </TableHeaderH>
              ))}
            </tr>
          </TableHeader>
          <TableBody>
            {
              searchableFeatureSwitches.map(({ displayName, whiteLabelUid, featureSwitches }) => (
                <tr key={whiteLabelUid}>
                  <td>
                    {displayName}
                  </td>
                  {Object.entries(featureSwitches).map(([name, value], key) => (
                    <td key={key}>
                      <FeatureSwitchButton
                        whiteLabelUid={whiteLabelUid}
                        featureSwitch={name}
                        on={value}
                        onClick={toggleFeatureSwitch}
                        type="whiteLabel"
                      />
                    </td>
                  ))}
                </tr>
              ))
            }
          </TableBody>
        </Table>
      }
    </div>
  )
})
